import { FaChevronRight } from "react-icons/fa";

const services = [
    { id: 1, name: "Product Photography", image: "/images/services-section/Service1.jpg" },
    { id: 2, name: "E-Commerce Photography", image: "/images/services-section/Service2.jpg" },
    { id: 3, name: "Food Photography", image: "/images/services-section/Service3.jpg" },
    { id: 4, name: "Brand Identity", image: "/images/services-section/Service4.jpg" },
    { id: 5, name: "Retail Space Design", image: "/images/services-section/Service5.jpg" },
    { id: 6, name: "UI/UX & Web Design", image: "/images/services-section/Service6.jpg" },
    { id: 7, name: "Social Media Assets", image: "/images/services-section/Service7.jpg" },
    { id: 8, name: "Marketing Consultancy", image: "/images/services-section/Service8.jpg" },
    { id: 9, name: "Photograph Workshop & Training", image: "/images/services-section/Service9.jpg" },
];

export default function Services() {
    return (
        <div className="mx-auto py-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {services.map((service) => (
                    <div
                        key={service.id}
                        className="bg-white shadow-lg rounded-2xl overflow-hidden transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl relative"
                    >
                        <img src={service.image} alt={service.name} className="w-full h-48 object-cover" />
                        <div className="p-4 flex justify-between items-center">
                            <h3 className="text-lg font-semibold">{service.name}</h3>
                            <div className="bg-gray-200 p-2 rounded-full">
                                <FaChevronRight className="text-gray-700" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
